module.exports = __webpack_public_path__ + "static/media/mic.df609130.png";